import { connect } from 'react-redux';
import DeliveryAccordion from './deliveryAccordion';

const mapStateToProps = ({ detailsPage }) => ({
  content: detailsPage.loadedProduct.contentSlotsJson.deliveryReturn
    ? detailsPage.loadedProduct.contentSlotsJson.deliveryReturn.components[0].details.content
    : '',
  title: detailsPage.loadedProduct.contentSlotsJson.deliveryReturn
    ? detailsPage.loadedProduct.contentSlotsJson.deliveryReturn.components[0].details.title
    : '',
});

export default connect(mapStateToProps)(DeliveryAccordion);
